// extracted by mini-css-extract-plugin
export default {"wrapper":"ipaf-popup-banner_wrapper__0hPTP","banner-wrapper":"ipaf-popup-banner_banner-wrapper__3kyQe","close-icon":"ipaf-popup-banner_close-icon__ZRgPL"};